import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { err: null, info: null };

  static getDerivedStateFromError(err) {
    return { err };
  }

  componentDidCatch(err, info) {
    // Log the React component stack to the console
    // eslint-disable-next-line no-console
    console.error('React stack →', info.componentStack);
    this.setState({ info });
  }

  render() {
    const { err, info } = this.state;
    if (err) {
      return (
        <pre style={{ whiteSpace: 'pre-wrap', padding: 24, color: 'red' }}>
          {err.message}
          {'\n\n'}
          {info?.componentStack}
        </pre>
      );
    }
    return this.props.children;
  }
}
